import { DateTimeFormat, formatDateTime, parseDate } from '@occc-app/lib/date';

export const formatScheduledDate = (scheduledDate?: Date | string | null): string => {
  if (!scheduledDate) return 'N/A';

  return formatDateTime(parseDate(scheduledDate), DateTimeFormat.DateTime12h);
};

export const splitTitleAndDescription = (text: string) => {
  const [title, ...rest] = text.trim().split(/\s+/);
  return {
    title,
    description: rest.join(' '),
  };
};
